import type { AuditTrailEvent } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { inflection } from '@piccolohealth/util';
import React from 'react';

interface Props extends ChakraV3.TagProps {
  event: AuditTrailEvent;
}

export const getColor = (event: AuditTrailEvent): string | undefined => {
  if (event.startsWith('PARTICIPANT')) {
    return 'blue';
  } else if (event.startsWith('BEHAVIOUR')) {
    return 'purple';
  } else if (event.startsWith('FORM')) {
    return 'green';
  } else if (event.startsWith('INCIDENT')) {
    return 'orange';
  } else if (event.startsWith('LABEL')) {
    return 'yellow';
  } else if (event.startsWith('LOCATION')) {
    return 'cyan';
  } else if (event.startsWith('ORGANIZATION')) {
    return 'red';
  } else if (event.startsWith('TEMPLATE')) {
    return 'teal';
  } else if (event.startsWith('USER')) {
    return 'pink';
  } else {
    return undefined;
  }
};

export const AuditTrailEventTag = (props: Props) => {
  const { event, ...rest } = props;
  const color = getColor(event);
  const text = inflection.titleize(event);

  return (
    <ChakraV3.Tag size='sm' colorPalette={color} {...rest}>
      {text}
    </ChakraV3.Tag>
  );
};
